import { useEffect, useState } from "react";
import { _ManufacturingStardard, _single } from "../../../core/services/dataBean/EntityCatalog";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import usePaginator from "../../theme/Component/usePaginator";
import { SelectProductiveProcessType } from "../ProductiveProcessType/SelectProductiveProcessType";
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { SelectorUmeasurement } from "../../bpm/config/Componentes/SelectorUmeasurement";
import { SelectProductEditor } from "./Components/SelectProductEditor";
import { PrintJson } from "../../theme/Component/PrintJson";
import { BasicButton } from "../../theme/Component/BasicButton";
import { RawMaterial } from "./RawMaterial/RawMaterial";
import { IndirectCost } from "./IndirectCost/IndirectCost";
import { Labour } from "./Labour/Labour";
import { toast } from "react-toastify";
import { RawMaterialByManufacturingVariant } from "./RawMaterialByManufacturingVariant";
import { _UpdateManufacturing } from "../../../core/services/dataBean/EntityCatalogVdos";

export const ManufacturingStandars = () => {

    const { lista, setLista, bean, setBean, instance, update, handleChange, deleteItemVoid } = useDataBean(_ManufacturingStardard);
    const updateManufacturing = useDataBean(_UpdateManufacturing);
    const [regex, setRegex] = useState<string>("");
    const [processID, setProcessID] = useState<number>(NaN);
    const [product, setProduct] = useState<number>(NaN);
    const [registers, setRegisters] = useState<number>(15);
    const paginador = usePaginator();
    const [modalactualizarcost, setModalactualizarcost] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalMaterialByvariant, setModalMaterialByvariant] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalMaterial, setModalMaterial] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalTask, setModalTask] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalIndirectCost, setModalIndirectCost] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });


    useEffect(() => {
        getLista()
    }, [paginador.page])

    const getLista = () => {
        instance.getManufacturingStardardByCode(regex != "" ? regex : null, processID ?? null, product ?? null, paginador.page, registers).then(
            (resp) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (registers ?? 15));
                    paginador.setRegiPerPage(registers)

                    setLista(resp.List)
                }
            }
        ).catch(
            err => { console.log(err) }
        )
    }
    const updateManufacturingStardardCost = () => {
        updateManufacturing.instance.updateManufacturingStardardCost(bean.IDManufacturingStardard).then(
            (resp) => {
                if (resp) {
                    toast.success('Actualizar')
                    setModalactualizarcost({ ...modalactualizarcost, "view": false })
                }
            }
        ).catch(
            err => { console.log(err) }
        )
    }
    const editaItem = () => {
        update().then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        deleteItemVoid(bean.IDManufacturingStardard).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDManufacturingStardard', visible: true },
        { title: 'Codigo', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo de Proceso Productivo', property: 'ProductiveProcessTypeName', visible: true },
        { title: 'Producto Final', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Almacén Destino', property: 'StoreName', visible: true },
        { title: 'Empleado', property: 'EmployeeName', visible: true },

    ]

    const create = () => {
        setBean({
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true, "name": "Agregar Estandar de Fabricación" });
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true, "name": "Editar Estandar de Fabricación" }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Estandar de Fabricación` }) } },
            { titulo: 'Actualizar Costo Estandar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalactualizarcost({ ...modalactualizarcost, "view": true }) } },
            { titulo: 'Lista de Inventario de Materia Prima (BOM)', icono: 'ri-file-edit-line', visible: _single.canDelete(), evento: () => { setModalMaterial({ ...modalMaterial, "view": true, "name": `Lista de materia Prima de ${bean.ProductName}` }) } },
            { titulo: 'Lista de Inventario de Materia Prima (BOM) por Talla/Variante', icono: 'ri-file-edit-line', visible: _single.canDelete(), evento: () => { setModalMaterialByvariant({ ...modalMaterialByvariant, "view": true, "name": `Lista de materia Prima de ${bean.ProductName}` }) } },
            { titulo: 'Costos Indirectos de Fabricación', icono: 'ri-money-dollar-box-line', visible: _single.canDelete(), evento: () => { setModalIndirectCost({ ...modalIndirectCost, "view": true, "name": `Costos Indirectos de ${bean.ProductName}` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);



    return (
        <div className="row">
            <div className="col-md-12">
                <BasicPage titulo="Catálogo de Estandares de Fabricación" >
                    <div className="row">
                        <div className="col-md-4">
                            <label>Texto</label>
                            <input type="text" className="form-control" value={regex} onChange={(e) => { setRegex(e.target.value) }} />
                        </div>
                        <div className="col-md-4">
                            <SelectProductiveProcessType idSelector={processID} onChange={(e) => { setProcessID(e) }} />
                        </div>
                        <div className="col-md-4">
                            <SelectProductEditor filterType={3} label="Producto Final" value={product} onChange={(e) => { setProduct(e.IDProduct) }} />
                        </div>
                        <div className="col-md-3 mt-2">
                            <BasicButton icon="ri-search-line" eventClick={() => { getLista() }} children={"Buscar"} />
                        </div>
                        <div className="col-md-12">
                            <BasicTable
                                listButtons={listaBotones()}
                                iconButtons={iconButtonsItem}
                                head={head} body={lista}
                                rowSet={setBean}
                                pageTop={paginador.page}
                                next={paginador.next}
                                back={paginador.back}
                                records={paginador}
                                customRows={registers}
                            />
                        </div>
                    </div>
                </BasicPage>
            </div>

            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteObjec}>
                    <strong>Eliminar Informacion de {bean.IDProductiveProcessType} - {bean.ProductName}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Nombre</label>
                            <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />
                            {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                        </div>
                        <div className="col-md-6">
                            <label>Código</label>
                            <input type="text" name="Code" className="form-control" value={bean.Code} onChange={handleChange} />

                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDProductiveProcessType') ? 'has-error' : ''}`}>Tipo de Proceso Productivo</label>
                            <SelectProductiveProcessType idSelector={bean.IDProductiveProcessType} onChange={(e) => { setBean({ ...bean, "IDProductiveProcessType": e }) }} label=" " />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDProduct') ? 'has-error' : ''}`}>Producto Final</label>
                            <SelectProductEditor label=" " filterType={3} value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }) }} />
                        </div>
                        <div className="col-md-6">
                            <label className={`${missingFields.includes('IDMeasurementUnit') ? 'has-error' : ''}`}>Unidad de Medida</label>
                            <SelectorUmeasurement idSelector={bean.IDMeasurementUnit} onChange={(e) => { setBean({ ...bean, "IDMeasurementUnit": e }) }} titulo=" " />
                        </div>
                        {/* <div className="col-md-6">
                            <label className={`${missingFields.includes('IDStoreDestinity') ? 'has-error' : ''}`}>Almacén Destino</label>
                            <SelectStoreEditor label=" " idSelector={bean.IDStoreDestinity} onChange={(e) => { setBean({ ...bean, "IDStoreDestinity": e.IDStore }) }} />
                        </div> */}
                        {/* <PrintJson json={bean} /> */}
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <Modal modal={modalactualizarcost} updateModal={setModalactualizarcost} eventModal={updateManufacturingStardardCost} onSubmitLabel="Actualizar Costo Estandar">
                    <div className="row">
                        <strong>Actualizar Costo Estandar {bean.IDManufacturingStardard} - {bean.Name} ?</strong>
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <Modal modal={modalMaterial} updateModal={setModalMaterial} >
                    <RawMaterial idManufacturingStardard={bean.IDManufacturingStardard} />
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalMaterialByvariant} updateModal={setModalMaterialByvariant} >
                    <RawMaterialByManufacturingVariant idManufacturingStardard={bean.IDManufacturingStardard} />
                </Modal>
            </div>

            <div className="col-md-12">
                <Modal modal={modalIndirectCost} updateModal={setModalIndirectCost} >
                    <IndirectCost idManufacturingStardard={bean.IDManufacturingStardard} />
                </Modal>
            </div>

            {/* <div className="col-md-12">
                <Modal modal={modalTask} updateModal={setModalTask} >
                    <Labour idManufacturingStardard={bean.IDManufacturingStardard} />
                </Modal>
            </div> */}

        </div>
    )
}



